<template>
    <form-item-wrapper :designer="designer" :field="field" :rules="rules" :design-state="designState"
        :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
        :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
        <input type="hidden" v-model="fieldModel" />
        <el-cascader ref="cascaderStore" v-model="areaArray" :options="options" style="width: 100%" :props="addressProps"
            :separator="field.options.separator" :show-all-levels="!field.options.showAllLevels"
            :placeholder="field.options.placeholder" :disabled="field.options.disabled" :clearable="field.options.clearable"
            :before-filter="beforeFilter" :filter-method="filterMethod" filterable @change="changeFun" @blur="blurFun" />
    </form-item-wrapper>
</template>
<script>
import PinyinMatch from "pinyin-match";
import FormItemWrapper from "@/components/form-designer/form-widget/field-widget/form-item-wrapper";
import emitter from "@/utils/emitter";
import i18n from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";
// import request from "@/utils/request";
export default {
    name: "addressEditorWidget",
    components: {
        FormItemWrapper,
    },
    componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
    mixins: [emitter, fieldMixin, i18n],
    inject: ["refList", "globalOptionData", "globalModel"],
    props: {
        field: Object,
        parentWidget: Object,
        parentList: Array,
        indexOfParentList: Number,
        designer: Object,

        designState: {
            type: Boolean,
            default: false,
        },

        subFormRowIndex: {
            /* 子表单组件行索引，从0开始计数 */ type: Number,
            default: -1,
        },
        subFormColIndex: {
            /* 子表单组件列索引，从0开始计数 */ type: Number,
            default: -1,
        },
        subFormRowId: {
            /* 子表单组件行Id，唯一id且不可变 */ type: String,
            default: "",
        },
    },
    data() {
        return {
            addressProps: {
                value: "value",
                label: "label",
                children: "children",
                checkStrictly: true,
                lazy: true,
                leaf: "leaf",
                lazyLoad: this.queryNode
            },
            defaultValue: this.field.options.defaultValue,
            rules: [],
            fieldModel: [],
            areaArray: [],
            areaArrayAll: [],
            areaArraySz: [],
            options: [],
            setInterval: '',
        };
    },
    watch: {
        areaArray: {
            handler: function (newVal,oldVal) {
                this.fieldModel=newVal || []
            },
            deep: true
        },
        fieldModel: {
            handler: function (newVal,oldVal) {
                let val = newVal || []
                if (Object?.prototype?.toString?.apply(val) !== "[object Array]") {
                    val = newVal.split(',')
                    this.setValue(val);
                    setTimeout(() => {
                        this.dispatch("VFormRender", "getAddressNames", [
                            this.presentText.replaceAll(this.field.options.separator, ''),
                            this.field.options.name,
                        ]);
                    }, 300)
                    return
                }
                if (this.areaArray.toString() !== val.toString()) {
                    this.init(val);
                }
            },
            deep: true
        },
    },
    created() {
        this.registerToRefList();
        this.initEventHandler();
        this.initFieldModel();
        this.buildFieldRules();
        this.fieldModel='440304003000'
        this.$nextTick(async () => {
            this.options = await this.loadGridData("");
            // this.areaArrayAll = await this.loadGridData("");
            // this.areaArraySz = await this.loadGridData("");
        })
    },
    mounted() {
        this.setInterval = setInterval(function () {
            var cascaderList = document.querySelectorAll(".el-cascader-node__label")
            for (var i = 0; i < cascaderList.length; i++) {
                cascaderList[i].onclick = function () {
                    if (this.previousElementSibling) this.previousElementSibling.click();
                };
            }
        }, 500);
    },
    computed: {
        presentText() {
            return this.$refs?.cascaderStore?.presentText || ''
        }
    },
    beforeDestroy() {
        this.unregisterFromRefList();
        clearInterval(this.setInterval)
    },
    methods: {
        async init(newVal) {
            const realAreaCode = this.generateAreaCodes(this.regionArray(newVal));
            if (realAreaCode.length > 3) {
                let fourOptions = await this.loadGridData(realAreaCode[2]);
                if (realAreaCode.length > 4) {
                    for (const item of fourOptions) {
                        if (item.value === realAreaCode[3]) {
                            item.children = await this.loadGridData(realAreaCode[3]);
                            item.children.forEach((x) => (x.leaf = true));
                        }
                    }
                }
                this.getItemChildren(this.options, realAreaCode[2], fourOptions, false);
            }
            this.$nextTick(() => {
                this.areaArray = realAreaCode;
            });
        },
        async changeAddType(type) {
            if (type) {
                this.options = this.filterDataByCity(this.options, "深圳市")
                // this.init("440000000000,440300000000")
            } else {
                this.options = await this.loadGridData("")
                this.init()

            }
        },
        filterDataByCity(data, cityName) {
            const filteredData = data.map(item => {
                if (item.label === cityName) {
                    return item;
                }
                return {
                    ...item,
                    children: item.children ? this.filterDataByCity(item.children, cityName) : []
                };
            });
            return filteredData.filter(item => item.label === cityName || item.children.length > 0);
        },
        // 调用关闭级联
        autoCloseCascaderDropdown() {
            if (this.$refs.cascaderStore) {
                this.$refs.cascaderStore.dropDownVisible = false;
            }
        },
        // 筛选节点拦截方法
        beforeFilter(value) {
            return value && value.length >= 2;
        },
        // 节点匹配方法
        filterMethod(node, keyword) {
            return PinyinMatch.match(node.label, keyword);
        },
        // 生成地址编码
        generateAreaCodes(code) {
            const areaCodes = [];
            if (!code) {
                return areaCodes;
            }
            areaCodes.push(code.substring(0, 2) + "0000000000");
            areaCodes.push(code.substring(0, 4) + "00000000");
            areaCodes.push(code.substring(0, 6) + "000000");
            areaCodes.push(code.substring(0, 9) + "000");
            areaCodes.push(code);
            return [...new Set(areaCodes)];
        },
        // 判断数据类型
        regionArray(codes) {
            if (Object?.prototype?.toString?.apply(codes) === "[object Array]") {
                return codes[codes.length - 1]
            } else if (
                Object?.prototype?.toString?.apply(codes) === "[object String]" &&
                codes.length > 0
            ) {
                const regionsTemp = codes.split(",");
                return regionsTemp[regionsTemp.length - 1]
            }
            return '';
        },
        // 级联懒加载数据
        async queryNode(node, resolve) {
            const { level, value } = node;

            // 选中1级，2级地址时，无需加载下一级数据
            if (level < 3) {
                resolve();
                return;
            }
            // 选中5级地址时，无需加载下一级数据，并关闭级联组件
            if (level === 5) {
                this.autoCloseCascaderDropdown();
                resolve();
                return;
            }
            const nodes = await this.loadGridData(value);
            // 选中地址时，接口未返回下一级数据则关闭级联组件
            if (nodes.length === 0) {
                this.autoCloseCascaderDropdown();
                resolve();
                return
            }
            nodes.forEach((x) => (x.leaf = level === 4));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            // 判断数据是否一致，避免添加重复数据
            if (nodes.toString() !== node.children.toString()) {
                resolve(nodes);
            } else {
                resolve();
            }
        },
        // 获取地址列表
        // async loadGridData(parentId) {
        //   return new Promise((resolve) => {
        //     request({
        //       url: this.field.options.url + parentId || '',
        //       method: 'get',
        //     }).then(response => {
        //       const { code, data } = response.data
        //       resolve(code === 0 ? data : [])
        //     });
        //   })
        // },
        // 获取地址列表
        async loadGridData(parentId) {
            return new Promise((resolve) => {
                if(window.apiConfig.key!='baoan'){
                    this.$http({
                        url: this.$http.adornUrl("/ntApi/handleRequest"), // 孕保系统固定请求此地址
                        data: this.$http.adornData({
                            uri: this.field.options.url + parentId || "", // 实际请求的外部系统api路径
                            type: "get",
                            hideLoading: true,
                        }),
                    }).then((response) => {
                        const { code, data } = response.data;
                        resolve(code === 0 ? data : []);
                    });
                }else{
                    this.$http({
                        url: this.field.options.url + parentId || "",
                        method: 'get',
                        hideLoading: true,
                        }).then((response) => {
                        const { code, data } = response.data;
                        resolve(code === 0 ? data : []);
                    });

                }

            });
        },
        // 暴露change方法
        async changeFun() {
            this.handleChangeEvent(this.areaArray);
        },
        getItemChildren(childrenData, value, resData, leafFlag) {
            if (childrenData.length > 0) {
                childrenData.forEach((childrenItem) => {
                    if (childrenItem.value === value) {
                        resData.forEach((x) => (x.leaf = leafFlag));
                        childrenItem.children = resData;
                    } else {
                        if (childrenItem.children) {
                            this.getItemChildren(
                                childrenItem.children,
                                value,
                                resData,
                                leafFlag
                            );
                        }
                    }
                });
            }
        },
        // 暴露blur方法
        blurFun() {
            this.handleBlurCustomEvent(this.getValue());
        },
    },
};
</script>
